<div *ngIf="selectedTeam()">
  <app-title-section
    [title]="title()"
    spacingBottom="24"
    size="2"
  ></app-title-section>
  <app-input
    id="searchText"
    type="search"
    size="small"
    width="full"
    icon="search"
    [spacingBottom]="InputFieldSpacing.X_SMALL"
    [inputValue]="searchInput"
    [disabled]="isLoading()"
    placeholder="{{ 'common.search' | translate }}"
    data-test-id="challenge-team-users-search-input"
  />

  <div class="challenge-team-users-container">
    @if (isLoading()) {
    <app-spinner data-test-id="challenge-team-users-spinner"></app-spinner>
    } @else if (filteredUsers()?.length) {
    <app-table
      [pageSize]="5"
      [page]="page()"
      [rowSelect]="true"
      [tableData]="filteredUsers()"
      [config]="tableConfig"
      data-test-id="challenge-team-users-table"
      (recordSelected)="userSelected($event)"
      (recordUnselected)="userUnselected($event)"
      class="challenge-team-users-table"
    ></app-table>
    } @else {
    <p class="challenge-no-users-found">
      {{ 'challenges.noUsersFound' | translate }}
    </p>
    }
  </div>
  <div class="challenge-users-actions">
    <app-button
      type="secondary"
      (handleClick)="onCancel()"
      spacingBottom="none"
      data-test-id="challenge-users-cancel-button"
      >{{ 'common.cancel' | translate }}</app-button
    >
    <app-button
      type="primary"
      (handleClick)="onConfirm()"
      spacingBottom="none"
      data-test-id="challenge-users-confirm-button"
      >{{ 'common.confirm' | translate }}</app-button
    >
  </div>
</div>
